import { render, staticRenderFns } from "./AdminGeneral.vue?vue&type=template&id=ac952fea&scoped=true&"
import script from "./AdminGeneral.vue?vue&type=script&lang=js&"
export * from "./AdminGeneral.vue?vue&type=script&lang=js&"
import style0 from "./AdminGeneral.vue?vue&type=style&index=0&id=ac952fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac952fea",
  null
  
)

export default component.exports